import Api from "@/services/Index";

const get = async (config)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/section/groups",config);
}
const show = async (id)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/section/groups/"+id);
}
const store = async(data)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/section/groups",data)
}
const update = async (id,data)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put("/section/groups/"+id,data)
}
const del = async(id)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete("/section/groups/"+id)
}

export default {
    get,
    show,
    store,
    update,
    del
}

